import config from "@/libs/config";

const BANK_XID_DOMAIN_NAME = config.XID_URL;

export const LOAN_SERVICE_CODE = "LOAN";

/**
 * 各サービス規約類URL取得
 */
export const planTermUrls: Record<string, any> = {
  // 指定サービスに関する特約
  planServiceTerm: {
    title: "指定サービスに関する特約",
    url: `${BANK_XID_DOMAIN_NAME}/terms/service`,
  },
  planPolicyDataProvisionTerm: {
    title: "利用者情報の第三者提供に関する特約",
    url: `${BANK_XID_DOMAIN_NAME}/terms/policy_data_provision`,
  },
  planPrivacyTerm: {
    title: "個人情報保護方針（プライバシーポリシー）",
    url: "https://corp.moneyforward.com/privacy/",
  },
  planCompanyBfmTerm: {
    title: "Mikatano 資金管理 利用規約",
    url: config.BFM_TERMS_OF_USE_URL,
  },
  planApiAgreementTerm: {
    title: "電子決済等代行業に関する表示等",
    url: "https://corp.moneyforward.com/api_agreement",
  },
  planCompanyDxfTerm: {
    title: "Mikatano ワークス 利用規約",
    url: config.DXF_TERMS_OF_USE_URL,
  },
  planCompanyInvoiceTerm: {
    title: "Mikatano インボイス管理 利用規約",
    url: config.INVOICE_TERMS_OF_USE_URL,
  },

  // 各サービスに紐づく規約類
  BFM: ["planCompanyBfmTerm", "planApiAgreementTerm"],
  DXF: ["planCompanyDxfTerm"],
  INVOICE: ["planCompanyInvoiceTerm"],
};
